import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ModalWrapper, NavLink, Dropdown, DropdownItem } from '@minerva-analytics/pantheon';
import { FaArrowRight } from 'react-icons/fa';

import defaultProfileImage from 'assets/defaultProfileImage.png';

import CustomModal from 'components/CustomModal';
import NotificationsDropdown from 'components/NotificationsDropdown';
import LoginForm from 'components/LoginForm';
import Logo from 'components/Logo';
import LogoIcon from 'components/Logo/quizHive_logo_2019_mobile.png';
import { facebookLogin } from 'store/user/actions/facebookLogin';
import { gmailLogin } from 'store/user/actions/gmailLogin';
import authedUser from 'store/user/selectors/authedUser';
import userActions from '../../store/user/actions';

import {
  HeaderContainer,
  HeaderMenu,
  HeaderLeft,
  HeaderRight,
  ProfileImage,
  SigninLink,
  SigninButton,
  SeeHowSmart,
  UserName,
  DropdownMenu,
  MobileLogo,
  DesktopLogo,
} from './Header.styles';

export class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loginOpen: false,
    };
  }

  onSelect = (v) => {
    const { logout, history, user, selectUser } = this.props;

    return () => {
      switch (v) {
        case `home`:
          history.push(`/`);
          break;
        case `profile`:
          selectUser(user.id);
          history.push(`/profile/${user.id}`);
          break;
        case `logout`:
          logout()
            .then(() => history.push(`/`))
            .catch(() => history.push(`/`));
          break;
        default:
        console.error(`${v.type} is not defined`); // eslint-disable-line
          break;
      }
    };
  }

  facebookLoginWithModuleClose = () => {
    this.props.facebookLogin(`header`);
    this.toggleModule();
  }

  gmailLoginWithModuleClose = () => {
    this.props.gmailLogin(`header`);
    this.toggleModule();
  }

  toggleModule = () => {
    this.setState({
      loginOpen: !this.state.loginOpen,
    });
  }

  render() {
    const { isAuthenticated, user } = this.props;
    const photo = user ? user.profile.photo : defaultProfileImage;
    const dropdownItems = [
      <DropdownItem key="user-name">
        <UserName>
          { user ? user.username : null }
        </UserName>
      </DropdownItem>,
      <DropdownItem key="home" onClick={ this.onSelect(`home`) }>
        Home
        <FaArrowRight />
      </DropdownItem>,
      <DropdownItem key="profile" onClick={ this.onSelect(`profile`) }>
        View your profile
        <FaArrowRight />
      </DropdownItem>,
      <DropdownItem key="logout" onClick={ this.onSelect(`logout`) }>
        Log out
        <FaArrowRight />
      </DropdownItem>,
    ];
    const modalBody = (
      <LoginForm
        facebookLogin={ this.facebookLoginWithModuleClose }
        gmailLogin={ this.gmailLoginWithModuleClose }
        headlineText="Sign up to receive a QuizHive question daily!"
      />
    );
    const headerRight = isAuthenticated
      ? (
        <HeaderRight>
          <NotificationsDropdown
            isAuthenticated={ isAuthenticated }
          />
          <Dropdown
            items={ dropdownItems }
            CustomMenu={ DropdownMenu }
          >
            <ProfileImage
              src={ photo }
              alt="The user's profile image"
            />
          </Dropdown>
        </HeaderRight>
      ) : (
        <HeaderRight>
          <SeeHowSmart>See How Smart You Really Are</SeeHowSmart>
          <SigninButton type="primary" onClick={ this.toggleModule }>
            <SigninLink>
            Sign Up / Login
            </SigninLink>
          </SigninButton>
        </HeaderRight>
      );

    return (
      <HeaderContainer>
        <HeaderMenu>
          <HeaderLeft>
            <NavLink to="/">
              <DesktopLogo>
                <Logo />
              </DesktopLogo>
              <MobileLogo src={LogoIcon} />
            </NavLink>
          </HeaderLeft>
          { headerRight }
        </HeaderMenu>
        <ModalWrapper
          closeModal={ this.toggleModule }
          isOpen={ this.state.loginOpen }
          backdropClosesModal
        >
          <CustomModal
            body={ modalBody }
            onCancel={ this.toggleModule }
          />
        </ModalWrapper>
      </HeaderContainer>
    );
  }
}

Header.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  user: PropTypes.object,
  facebookLogin: PropTypes.func.isRequired,
  gmailLogin: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
  history: PropTypes.object,
  selectUser: PropTypes.func.isRequired,
};

export default connect((state) => {
  return {
    user: authedUser(state),
  };
}, {
  facebookLogin,
  gmailLogin,
  logout: userActions.logout,
  selectUser: userActions.selectUser,
})(withRouter(Header));
